import * as React from 'react';
import { forwardRef, } from 'react';
import { useRadio } from '../hooks/useRadio';
import { CheckboxChangeEventTarget } from './CheckboxExclusiveAli';

export const RadioExclusiveAli = forwardRef<HTMLSpanElement, Partial<CheckboxChangeEventTarget>>(
  (props, ref) => {
    const {
      checked,
      defaultChecked = false,
      value,
      onChange,
      children,
      ...others
    } = props;

    const { getInputProps, getRootProps } = useRadio({
      ...others,
      value,
      name,
      checked,
      defaultChecked,
      onChange,
    });

    const inputProps = getInputProps({}, ref);
    return (
      <label
      {...getRootProps()}
      >
        <input
          {...inputProps}
        />
      </label>
    );
  },
);

